module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ../~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
 ** module id = 2736
 ** module chunks = 1
 **/